import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './tabs.module.scss';
const TabPanel = ({ children, disabled, id, }) => {
    const tabPanelClass = useMemo(() => {
        return classNames(styles.tab_panel, {
            [styles.disabled]: disabled,
        });
    }, []);
    return (_jsx("div", { className: tabPanelClass, role: "tabpanel", id: `rc-tab-panel-${id}`, "aria-labelledby": `rc-tab-${id}`, children: children }));
};
TabPanel.displayName = 'TabPanel';
export { TabPanel };
